import { render, staticRenderFns } from "./BusinessDetailsIcon.vue?vue&type=template&id=4d357b92&"
import script from "./BusinessDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./BusinessDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports